import { type CSSProperties, Suspense, useRef } from "react";
import CSSTransition from "react-transition-group/CSSTransition";
import { PixieChunk } from "@/components/shopwindow/ask/pixieChunk";
import type { PixieHost } from "@/types/pixieHost";

type PixieWorkspaceProps = {
  open?: boolean;
  compact?: boolean;
  host: PixieHost;
  onExit?: () => void;
  onExited?: () => void;
  style?: CSSProperties;
};

// Pixie's Workspace: her chat beside the video grid, over the video (and the
// recipe panel on desktop). Mounted while Pixie is the open window.
export default function PixieWorkspace(props: PixieWorkspaceProps) {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <CSSTransition
      nodeRef={nodeRef}
      classNames="pixie-workspace"
      in={props.open}
      mountOnEnter
      unmountOnExit
      timeout={600}
      onExit={props.onExit}
      onExited={props.onExited}
    >
      <div
        ref={nodeRef}
        className={`pixie-workspace${props.compact ? " pixie-workspace--compact" : ""}`}
        style={props.style}
      >
        <Suspense fallback={null}>
          <PixieChunk.Component compact={props.compact} host={props.host} />
        </Suspense>
      </div>
    </CSSTransition>
  );
}
